/**
 * Default: Modules > Solr > Form
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import SelectorEngine from '../../../../shared/dom/selector-engine';
import EventHandler from '../../../../shared/dom/event-handler';

// -------
// Private
// -------

const NAME = 'solr';

const initLabelAsPlaceholder = () => {
	const COLLECTION = SelectorEngine.find(`.${NAME}-form .${NAME}-form__search`);

	if(!COLLECTION.length) return;

	for(let element of COLLECTION) {
		const INPUT = SelectorEngine.findOne(`.form-control`, element);
		const LABEL = SelectorEngine.findOne(`.form-label`, element);

		if(!INPUT || !LABEL) return;

		EventHandler.on(INPUT, 'keyup', () => {
			checkSearchInputValue(INPUT, LABEL);
		});

		EventHandler.on(LABEL, 'click', () => {
			INPUT.focus();
		});

		checkSearchInputValue(INPUT, LABEL);
	}
};

const checkSearchInputValue = (input, label) => {
	label.style.display = input.value === '' ? 'block' : 'none';
};

// -------
// Public
// -------

const init = () => {
	initLabelAsPlaceholder();
};

// Execute
init();